module.exports = __webpack_public_path__ + "media/about/matt-reason-35cf56cb.jpg";